
import { useMemo } from "react"
import { FileUploadIndicators } from "../../../../indicators/components/forms/fields/FileUploadIndicators";
import { updateVehicleDocument } from "../../../../../common/services/vehicles.api";


type DocumentIndicatorUploadProps = {
  vehicleId: string;
  currentPath: string[];
}

export function FineDocumentsRow(props: DocumentIndicatorUploadProps) {
  const pathToUpload = useMemo(() => `fine-vehicles/${props.vehicleId}`, [props.vehicleId])

  const saveIndicatorUpload = async (fineUpload) => {
    const fineUploadArray = Array.isArray(fineUpload) ? fineUpload : [fineUpload];
    await updateVehicleDocument(props.vehicleId, {
      fineUpload: fineUploadArray,
    })
  }

  return (
    <div className="col-span-3 bg-gray/40 p-4 dark:text-black rounded-md">
      <h2 className="text-2xl font-semibold mb-4">Enviar Comprovante da multa de transito</h2>
      <div className="flex flex-col items-stretch">
        <div className={"flex flex-col space-y-2 p-5 my-0 rounded"}>
          <FileUploadIndicators
            onChange={saveIndicatorUpload}
            pathToUpload={pathToUpload}
            currentPath={props.currentPath}
          />
        </div>
      </div>
    </div>
  );
}